import reduce from 'lodash/reduce';
import * as c from '../constants';


const INIT_STATE = {
  level: 0,
  list: {}
};


export default function(state = INIT_STATE, action) {
  switch (action.type) {
    case c.HOTKEY_TMP_RESET: {
      return INIT_STATE;
    }

    case c.HOTKEY_TMP_SET_LEVEL: {
      const { payload: level } = action;
      
      return {
        ...state,
        level: level,
        list: {
          ...state.list,
          [level]: tabReducer(state.list[level], action)
        }
      }
    }

    case c.HOTKEY_TMP_SET_TABS: {
      const { payload: { level } } = action;

      return {
        ...state,
        list: {
          ...state.list,
          [level]: tabReducer(state.list[level], action)
        }
      }
    }

    case c.HOTKEY_TMP_SET_SELECTED_TAB: {
      const { payload: { level } } = action;

      return {
        ...state,
        list: {
          ...state.list,
          [level]: tabReducer(state.list[level], action)
        }
      }
    }

    case c.HOTKEY_TMP_RESET_LEVEL_SAVE: {
      return {
        ...state,
        list: reduce((next, value, key) => ({
          ...next,
          [key]: {
            ...value,
            saved: false
          }
        }), state.list)
      }
    }

    case c.HOTKEY_TMP_MARK_LEVEL_SAVE: {
      const { payload: { level } } = action;

      return {
        ...state,
        list: {
          ...state.list,
          [level]: tabReducer(state.list[level], action)
        }
      }
    }

    default: {
      return state;
    }
  }
}


const TAB_INIT_STATE = {
  isFetching: false,
  selected: {},
  items: [],
  saved: false
}


function tabReducer(state = TAB_INIT_STATE, action) {
  switch (action.type) {
    case c.HOTKEY_TMP_SET_TABS: {
      const { payload: { tabs } } = action;

      return {
        ...state,
        items: tabs,
        saved: false
      }
    }
      
    case c.HOTKEY_TMP_SET_SELECTED_TAB: {
      const { payload: { tab } } = action;
      
      return {
        ...state,
        selected: tab
      }
    }

    case c.HOTKEY_TMP_MARK_LEVEL_SAVE: {
      return {
        ...state,
        saved: true
      }
    }
  
    default: {
      return state;
    }
  }
}
